import { _IDLE, _BUSY, _ALERT_TYPES, _LANGUAGE } from './AppAction';
import { stringIsNullOrEmpty } from '../util/Util'
import i18n from './../localization/i18n';
import { Language } from '../util/Constant.js';

const _INITIAL_STATE = {
    isBusy: false,
    message: i18n.t("PLEASE_WAIT"),
    alert: {},
    responseMessage: '',
    language: Language._ENGLISH
};

var _busyCount = 0;

/// <summary>
/// Author : Yong Sheng Chuan
/// </summary>
export default (state = _INITIAL_STATE, action) => {
    switch (action.type) {
        case _BUSY:
            _busyCount++;
            return {
                ...state,
                isBusy: true,
                message: stringIsNullOrEmpty(action.message) ? _INITIAL_STATE.message : action.message,
            }
            break;
        case _IDLE:
            _busyCount = Math.max(--_busyCount, 0);
            return {
                ...state,
                isBusy: (_busyCount != 0),
            }
            break;
        case _ALERT_TYPES.SET_ALERT:
            return {
                ...state,
                alert: Object.keys(state.alert) == 0 ? action.alert : state.alert
            };
            break;
        case _ALERT_TYPES.NONE:
            return {
                ...state,
                alert: {}
            };
            break;
        case _LANGUAGE:
            return {
                ...state,
                language: action.content
            };
            break;
        default:
            return state;
            break;
    }
};
